/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBookingStatusResponseDto
 */
export interface GetBookingStatusResponseDto {
    /**
     * Статус брони
     * @type {string}
     * @memberof GetBookingStatusResponseDto
     */
    status: GetBookingStatusResponseDtoStatusEnum;
    /**
     * Платёжная ссылка
     * @type {string}
     * @memberof GetBookingStatusResponseDto
     */
    paymentUrl: string;
}


/**
 * @export
 */
export const GetBookingStatusResponseDtoStatusEnum = {
    Booked: 'BOOKED',
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    Cancelled: 'CANCELLED',
    Failed: 'FAILED',
    PaymentFailed: 'PAYMENT_FAILED'
} as const;
export type GetBookingStatusResponseDtoStatusEnum = typeof GetBookingStatusResponseDtoStatusEnum[keyof typeof GetBookingStatusResponseDtoStatusEnum];


/**
 * Check if a given object implements the GetBookingStatusResponseDto interface.
 */
export function instanceOfGetBookingStatusResponseDto(value: object): value is GetBookingStatusResponseDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('paymentUrl' in value) || value['paymentUrl'] === undefined) return false;
    return true;
}

export function GetBookingStatusResponseDtoFromJSON(json: any): GetBookingStatusResponseDto {
    return GetBookingStatusResponseDtoFromJSONTyped(json, false);
}

export function GetBookingStatusResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBookingStatusResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'paymentUrl': json['paymentUrl'],
    };
}

  export function GetBookingStatusResponseDtoToJSON(json: any): GetBookingStatusResponseDto {
      return GetBookingStatusResponseDtoToJSONTyped(json, false);
  }

  export function GetBookingStatusResponseDtoToJSONTyped(value?: GetBookingStatusResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'paymentUrl': value['paymentUrl'],
    };
}

